/* global analytics */

/**
 * Wrapper for analytics.track method: Tracks an specific event.
 * @param {string} event
 * @param {object} payload
 * @returns
 */
const analyticsTrack = (event, payload) => analytics.track(event, payload)

export default analyticsTrack
